import $ from 'jquery'
import _throttle from 'lodash/throttle'

const defaultConfig = {
  width: '100%',
  height: '600',
}

const embeds = []
let windowWidth = $(window).width()
let windowHeight = $(window).height()

export function init() {
  $('[data-embed]').each((i, elem) => {
    const $elem = $(elem)
    const config = $elem.data('embed') || {}
    $elem.find('iframe').attr(Object.assign({}, defaultConfig, config))
    embeds.push($elem)
  })

  $('[data-embed-media]').each((i, elem) => {
    // add class hide onClick
    const $elem = $(elem)
    $elem.on('click', () => {
      console.log('click')
      if (!$elem.hasClass('hide')) {
        $elem.addClass('hide-embed')
      }
    })
  })

  $(window).on('resize', handleResize)
  _handleResize()
}

function _handleResize() {
  windowWidth = $(window).width()
  windowHeight = $(window).height()
  embeds.forEach(($embed) => {
    if ($('.album-cover').length) {
      $embed.find('iframe').height($('.album-cover').width())
    } else {
      $embed.find('iframe').height($embed.height())
    }
  })
}
const handleResize = _throttle(_handleResize, 1000 / 30)
